import Component from "./Dropdown";
import Button from "./components/Button/DropdownButton";
import Item from "./components/Item/DropdownItem";
import Menu from "./components/Menu/DropdownMenu";

export const Dropdown = Object.assign(Component, {
    Button,
    Menu,
    Item,
});

export { useDropdownStore } from "./store/store";

export { isCurrentKey } from "./components/Menu/utils/keyboard";
export * as Menus from "./components/Menu/components";

export type { IDropdown, IDropdownRef, MenuProps } from "./types";
